import React from 'react'
import Accordion from '../../components/Accordion'
import _ from 'lodash';


const ContentAccordion = ({ entity, small }) => {
  const title = _.get(entity, 'fieldTitle', null)
  const items = entity.fieldItems.map(item => {
    let content = _.get(item.entity, 'fieldBody.processed', '')

    if (item.entity.__typename === 'CMS_ParagraphAccordionItemReusableContent') {
      content = _.get(item.entity, 'fieldBodyResuableContent.entity.description.value', '')
    }

    return {
      id: _.get(item.entity, 'entityId', null),
      anchor: _.get(item.entity, 'fieldAnchor', null),
      title: _.get(item.entity, 'fieldTitle', ''),
      content: content,
    }
  })

  return (
    <section>
      <Accordion allowZeroExpanded={true} title={title} items={items} small={small} />
    </section>
  )
}

export default ContentAccordion
